/* istanbul ignore file */
import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';

import {SelectOption} from '@veneer/core';

import {Role} from '@br/idm-api';

import SelectFilter from './SelectFilter';

const RoleFilter = <K extends string, F extends Partial<Record<K, string>>>({
    label,
    field,
    filters,
    setFilters,
    getRoles,
}: {
    label: string;
    field: K;
    filters: F;
    setFilters: Dispatch<SetStateAction<F>>;
    getRoles: () => Promise<Role[]>;
}): JSX.Element => {
    const [{roles, loading}, setState] = useState<{
        loading: boolean;
        roles: SelectOption<string>[];
    }>({
        loading: true,
        roles: [],
    });
    useEffect(() => {
        void getRoles().then(roles =>
            setState({roles: roles.map(role => ({value: role.id, label: role.name})), loading: false})
        );
    }, [getRoles]);

    return (
        <SelectFilter
            data-testid="role-filter"
            label={label}
            field={field}
            filters={filters}
            setFilters={setFilters}
            options={roles}
            disabled={loading}
        />
    );
};

export default RoleFilter;
